import { createSlice } from '@reduxjs/toolkit';
import {addMonths, addYears,  startOfYear, endOfYear} from "date-fns";
import {toKSTISOString, toKSTISOStringEnd} from "../../components/commonmethod/CommonMethod";


const today = new Date();
const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

const threeMonthBeforeFirstDay = new Date(new Date().getFullYear(), new Date().getMonth() - 3, 1);

// 오늘로부터 3개월 전 부터 오늘까지
const threeMonthFromNow = {
    startDate: toKSTISOString(addMonths(today, -3)),
    endDate: toKSTISOStringEnd(today),
};

const threeMonthBefore = {
    startDate: toKSTISOString(threeMonthBeforeFirstDay),
    endDate: toKSTISOStringEnd(lastDayOfMonth),
}

const startDate = {
    startDate: toKSTISOString(today),
    endDate: null,
};
const thisDay = {
    startDate: toKSTISOString(today),
    endDate: toKSTISOStringEnd(today),
};

const thisMonthAndClick = {
    startDate: toKSTISOString(firstDayOfMonth),
    endDate: toKSTISOStringEnd(lastDayOfMonth),
    clickedDate: toKSTISOString(today),
};
const thisMonth = {
    startDate: toKSTISOString(firstDayOfMonth),
    endDate: toKSTISOStringEnd(lastDayOfMonth),
};
const inspectionCumulative = {
    entityName:'INSPECTION',
    startDate: toKSTISOString(firstDayOfMonth),
    endDate: toKSTISOStringEnd(lastDayOfMonth),
};
const workCumulative = {
    entityName:'WORK',
    startDate: toKSTISOString(firstDayOfMonth),
    endDate: toKSTISOStringEnd(lastDayOfMonth),
};
const errorCumulative = {
    entityName:'INCIDENT',
    startDate: toKSTISOString(firstDayOfMonth),
    endDate: toKSTISOStringEnd(lastDayOfMonth),
};
//오늘로 부터 1년 전 부터 오늘까지
const OneYearFromNow = {
    startDate: toKSTISOString(addYears(today, -3)),
    endDate: toKSTISOString(today),
};

//올해 1월1일 ~ 12월 31일
const thisYear = {
    startDate: toKSTISOString(startOfYear(today)),
    endDate: toKSTISOString(endOfYear(today)),
};

//오늘이 속한 분기
const getCurrentQuarter = (date) => {
    const year = date.getFullYear();
    const quarters = [
        { start: new Date(year, 0, 1), end: new Date(year, 2, 31) },  // 1분기
        { start: new Date(year, 3, 1), end: new Date(year, 5, 30) },  // 2분기
        { start: new Date(year, 6, 1), end: new Date(year, 8, 30) },  // 3분기
        { start: new Date(year, 9, 1), end: new Date(year, 11, 31) }  // 4분기
    ];

    for (let i = 0; i < quarters.length; i++) {
        if (date >= quarters[i].start && date <= quarters[i].end) {
            return {
                startDate: toKSTISOString(quarters[i].start),
                endDate: toKSTISOString(quarters[i].end)
            };
        }
    }

    // 이론상 도달하지 않아야 하는 곳
    return null;
};



//대쉬보드 12 컴포넌트 각자의 검색용 날짜
const initialState = {
    1: threeMonthFromNow,
    2: startDate,
    3: thisYear,
    // 4: getCurrentQuarter(today),
    4: thisYear,
    5: threeMonthFromNow,
    6: threeMonthFromNow,
    '서비스요청 처리현황': thisMonth,
    '자산관리내역': thisMonthAndClick,
    '장애처리현황': errorCumulative,
    '작업처리현황': workCumulative,
    '점검처리현황': inspectionCumulative,
    '업무달력': thisMonthAndClick,
    '업무목록': thisDay,
    '유지관리 업무현황': 1,
    '업무준수율': thisMonth,
    '월간 장애비율': thisMonth,
    'SLA 대시보드' : threeMonthBefore,
    '업무별 처리현황' : 1,
    '진행단계별 현황' : 1,
};

const dateSlice = createSlice({
    name: 'date',
    initialState,
    reducers: {
        setDate(state, action) {
            const { keys, ...dates } = action.payload;
            // 특정 키에 대해 상태 업데이트
            state[keys] = { ...state[keys], ...dates };
        },
        setValue(state, action) {
            const { keys, value } = action.payload;
            // 특정 키에 대해 상태 업데이트
            state[keys] = value;
        },
    },
});

export const getDate = (state, keys) => {
    return state.date[keys] ?? threeMonthFromNow;
};
export const { setDate, setValue } = dateSlice.actions;
export default dateSlice.reducer;
